import React from 'react'

const Backsound = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0052 15.4851C8.66492 14.6196 8.66492 12.3801 10.0052 11.5147L18.0975 6.28949C19.3988 5.44725 21 6.54224 21 8.27396V18.7251C21 20.4575 19.3995 21.5518 18.0975 20.711L10.0052 15.4851Z" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M6 18.7505L6 8.25065" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8"></path>
</svg>
    )
}

export default Backsound
